import React, { useRef, ReactNode } from "react"
import { Loader } from "dash-styled"
import { useRenderedSize } from "../../../Hooks/useRenderedSize"

interface LoadingContainerProps {
    children?: ReactNode
    className?: string
    defaultSize: { width?: number; height?: number }
}

/**
 * This component renders passed children, or a spinner if children is `undefined`.
 *
 * The width and height of the rendering area when the spinner is rendered is
 * decided accordingly to the `defaultSize` or the size of children which was there previously.
 * This effectively avoids the UI to jump around too much when children changes
 * from one to another via a loading state.
 */
export function LoadingContainer({
    children,
    className,
    defaultSize
}: LoadingContainerProps) {
    const bodyRef = useRef<HTMLDivElement>(null)
    const size = useRenderedSize(bodyRef, {
        width: defaultSize.width ?? 0,
        height: defaultSize.height ?? 0
    })

    return children === undefined ? (
        <div
            style={{
                height: `${size.height}px`,
                width: `${size.width}px`
            }}
        >
            <Loader absolute={true} />
        </div>
    ) : (
        <div ref={bodyRef} className={className}>
            {children}
        </div>
    )
}
